import globalAxios from 'axios';
import { ref } from 'vue';

//import { useAuth } from '~/auth/useAuth';

const isLoading = ref(false);
globalAxios.interceptors.request.use(
  async (config) => {
    isLoading.value = true;
    //check cache => future todo (see: useAuth.ts)
    //const apiToken = await useAuth().getApiToken();
    config.headers.Authorization = 'Bearer ' + 'apiToken';

    //Fix "Refused to set unsafe heaader "User-Agent" (see: https://hops.liebherr.com/browse/HRMIT-57259)
    config.headers.delete('User-Agent');

    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);
globalAxios.interceptors.response.use(
  (config) => {
    isLoading.value = false;
    return config;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);

export { isLoading };
